export default __webpack_public_path__ + "static/media/temps.d1d05f62.jpg";